const _excluded = ["option", "selected", "size", "highlighted", "label"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { ListItemLayout } from "../ListItemLayout";
export const MultipleOption = /*#__PURE__*/React.forwardRef(function OptionComponent(_ref, ref) {
  let {
      option,
      selected,
      size = "md",
      highlighted,
      label
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(ListItemLayout, {
    primary: label,
    disabled: option.disabled,
    secondary: option.secondary,
    selected: !option.isCustom ? selected : undefined,
    selectionMode: "multiple",
    variant: size === "sm" ? "sm" : "base",
    highlighted: highlighted
  }));
});
export function renderMultipleOptionDefault(props) {
  return /*#__PURE__*/React.createElement(MultipleOption, props);
}